module.exports = __webpack_public_path__ + "img/TCALCI_specific_male_99.d0dbd63d.png";